import React, { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import AdsOverviewTable from "./AdsOverviewTable";

const GoogleAnalyticsAdsOverview = () => {

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h4" fontWeight={700} sx={{ fontSize: "32px" }}>
            Analytics Overview
          </Typography>
          <Typography sx={{ fontSize: "14px", marginTop: "4px" }} color="text.secondary">
            Track all your google analytics
          </Typography>
        </Box>
      </Stack>

      <AdsOverviewTable/>

    </>
  );
};

export default GoogleAnalyticsAdsOverview;
